import { render, staticRenderFns } from "./TeacherPhotoReview.vue?vue&type=template&id=dc514988&scoped=true"
import script from "./TeacherPhotoReview.vue?vue&type=script&lang=js"
export * from "./TeacherPhotoReview.vue?vue&type=script&lang=js"
import style0 from "./TeacherPhotoReview.vue?vue&type=style&index=0&id=dc514988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc514988",
  null
  
)

export default component.exports